module.exports = __webpack_public_path__ + "static/media/hall-P1.d47e1c12.svg";